// extracted by mini-css-extract-plugin
module.exports = {"status":"DisplayStatus_status__2hPkj","gameover":"DisplayStatus_gameover__2Fl6u","gameoverMessage":"DisplayStatus_gameoverMessage__1G4Ow","restart":"DisplayStatus_restart__2tXND"};